export default function BrandMark({ className = '' }) {
  return (
    <span
      className={`font-display text-lg font-bold tracking-tight text-ink ${className}`}
    >
      myly
    </span>
  );
}
